/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { http, HttpResponse } from 'msw';
import type { UserPreferences } from './api';

export const createUserPreferencesEndpoints = (): ReturnType<
  typeof http.get
>[] => {
  let preferences: UserPreferences = {};
  return [
    http.get(/.*\/user\/preferences$/, () => HttpResponse.json(preferences)),
    http.all(
      /.*\/user\/preferences\/favourite-presets\/(workspace|view)\/(.+)$/,
      ({ request, params }) => {
        if (!['PUT', 'DELETE'].includes(request.method)) {
          return HttpResponse.json({}, { status: 405 });
        }
        const key = `${params[0]}:${decodeURIComponent(String(params[1]))}`;
        const favourites = preferences.favouritePresets ?? [];
        preferences = {
          ...preferences,
          favouritePresets:
            request.method === 'PUT'
              ? Array.from(new Set([...favourites, key]))
              : favourites.filter((value) => value !== key),
        };
        return HttpResponse.json(preferences);
      },
    ),
  ];
};
